<template>
  <div class="casino-sub-navigation">
    <ul class="casino-sub-nav">
      <li v-for="child in children" :key="child.id" class="casino-sub-nav-item">
        <router-link v-if="['INTERNAL', 'GROUP'].includes(child.linkType)" :to="{ path: '/' + $i18n.locale + child.uri || '/' }" :id="'casino-sub-nav-item-' + child.id" class="item-link" active-class="active-sub-item">
<!--          <icon v-if="child.cssClass && child.cssClass !=='default'" :name="child.cssClass"></icon>-->
          <span class="item-text">{{ child.text }}</span>
        </router-link>
        <a :href="child.uri" v-else-if="child.linkType === 'URL'" :class="[child.cssClass, 'item-link']" :setTarget="setExternalNavigationTarget(`casino-sub-nav-item-${child.id}`, child.target)" :id="'casino-sub-nav-item-' + child.id" :rel="'external'" :aria-label="child.text">
<!--          <icon v-if="child.cssClass && child.cssClass !=='default'" :name="child.cssClass"></icon>-->
          <span class="item-text">{{ child.text }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import Screen from '@/components/mixins/Screen'
// import Icon from '@/components/common/Icon'
import Casino from '@/components/mixins/Casino'
export default {
  name: 'casinoSubNavigation',
  props: [
    'children'
  ],
  mixins: [
    Screen,
    Casino
  ],
  components: {},
  data () {
    return {}
  },
  computed: {},
  methods: {},
  mounted () {}
}
</script>

<style lang="stylus">
@import '~@/css/config'
.casino-sub-navigation
  margin: 10px 5px 0 0
  display flex
  justify-content center
  .casino-sub-nav
    display: inline-flex
    gap: 12px
    list-style: none
    border-top-left-radius: 0
    border-top-right-radius: 0
    //background: var(--coupon-bgr) !important
    height: 45px
    background: #262332
    padding: 5px 10px 0 10px
    .item-link
      min-height 40px
  .casino-sub-nav-item
    min-width: 150px
    height: 38px
  .casino-sub-nav-item a
    display: block
    padding: 6px 14px
    font-size: 13px
    line-height: 1
    text-align: center
    cursor: pointer
    transition: 0.15s

  .casino-sub-nav-item
    margin-top 5px
    .item-text
      color: var(--tab-color) !important
      text-transform: none
      font-family: 'Roboto Condensed Bold'
      line-height: 14px
      min-width: 70px
      font-size: 16px
  .casino-sub-nav-item a.active-sub-item
    box-shadow: none !important
    background: #13161F !important
    border-top-left-radius: 5px
    border-top-right-radius: 5px
    .item-text
      color: var(--active-tab-color) !important
      font-weight: normal !important
</style>



// WEBPACK FOOTER //
// src/components/igaming/partials/casinoSubNavigation.vue